export const SERVICE_GROUPS_QUERY_KEY = 'serviceGroups'
export const DEACTIVATED_SERVICE_GROUPS_QUERY_KEY = 'deactivatedServiceGroups'
